import { Link, useLocation, useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { useEffect } from "react";
import useStore from "../store/useStore";
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import api from "../utils/api";

import MainOffice from "../components/main/MainOffice";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import { Box, Button, CircularProgress, Stack, SvgIcon, Toolbar, Typography } from "@mui/material";
import logo from "../styles/images/dual_logo.png";
import logo2 from "../styles/images/logo2.png";


const Bottom = () => {
  const setBottomNavValue = useStore((state) => state.setBottomNavValue);
  const bottomNavValue = useStore((state) => state.bottomNavValue);
  const location = useLocation();
  const navigate = useNavigate();

  const [remainSecond, setRemainSecond] = React.useState(60 * 60); // 초기 남은 시간 (30분)
  const userName: any = localStorage.getItem('userName');

  useEffect(() => {
    const pathname = location.pathname;

    if (pathname !== '/Join/JoinAgree') {
      permissionCheck();
    }

    if (pathname === '/') {
      // setBottomNavValue('home');
    } else if (pathname.startsWith('/reservation') || pathname.startsWith('/ConsultationReservation') || pathname.startsWith('/MyPage/ReservationView') || pathname.startsWith('/MyPage/ReservationBeforeView') || pathname.startsWith('/stress')) {
      // setBottomNavValue('reservation');
      setOpenMenus(prev => ({ ...prev, reservation: true }));
    } else if (pathname.startsWith('/MyPage/HealthResult') || pathname.startsWith('/MyPage/HealthMResult') || pathname.startsWith('/hra')) {
      setOpenMenus(prev => ({ ...prev, result: true }));
    } else if (pathname.startsWith('/encyclopedia')) {
      setOpenMenus(prev => ({ ...prev, healthInfo: true }));
    } else if (pathname.startsWith('/HealthResult')) {
      setOpenMenus(prev => ({ ...prev, healthInfo: true }));
    } else if (pathname.startsWith('/HealthMResult')) {
      setOpenMenus(prev => ({ ...prev, healthInfo: true }));
    } else if (pathname.startsWith('/comparisonHospital') || pathname.startsWith('/Information') || pathname.startsWith('/Notice')) {
      setOpenMenus(prev => ({ ...prev, guide: true }));
    } else if (pathname.startsWith('/CustomerServiceFaq') || pathname.startsWith('/check')) {
      setOpenMenus(prev => ({ ...prev, service: true }));
    } /* else if (pathname.startsWith('/MoreMenu') || pathname.startsWith('/News') || pathname.startsWith('/Notice')
      || pathname.startsWith('/Policy') || pathname.startsWith('/Version') || pathname.startsWith('/MyPage')) {
      setBottomNavValue('MoreMenu');
    } */
  }, [location.pathname, setBottomNavValue]);

  // 세션 useEffect
  useEffect(() => {
    // 타이머 함수
    const timer = () => {
      setRemainSecond(prevRemainSecond => {
        if (prevRemainSecond > 0) {
          return prevRemainSecond - 1;
        } else {
          // 세션 만료 처리
          localStorage.clear();
          alert("세션이 만료되었습니다. 로그인 후 이용해주세요.");
          navigate('/login');
          return 0;
        }
      });
    };

    // 타이머를 1초마다 실행
    const intervalId = setInterval(timer, 1000);

    // 컴포넌트가 언마운트 될 때 타이머를 정리
    return () => clearInterval(intervalId);

  }, [navigate])

  const [openMenus, setOpenMenus] = React.useState({
    reservation: false,
    result: false,
    healthInfo: false,
    guide: false,
    service: false,
  });

  const handleClick = (menuName: keyof typeof openMenus) => {
    setOpenMenus(() => {

      const newState = {
        reservation: false,
        result: false,
        healthInfo: false,
        guide: false,
        service: false,
      };

      return {
        ...newState,
        [menuName]: true
      };
    });
  };

  function permissionCheck() {
    // 로그인 안되어있거나, 유효하지 않은 토큰을 가지고 있을 때 => 로그아웃
    const token: any = window.localStorage.getItem("token");
    const userId: any = localStorage.getItem('userID');

    if (token == null) {
      // location.href = "/login";
      if (userId == null || userId == '' || token == '') {
        navigate('/login');
      } else {
        let sendItems: any = new Object();
        sendItems.id = userId;
        sendItems.token = token;
        api.post('permission/whoIs', sendItems)
          .then(res => {
            // console.log(res);
            if (res.data.message === "Success") {
              localStorage.setItem("token", token);
              localStorage.setItem("userID", userId);
              localStorage.setItem("userName", res.data.name);
              localStorage.setItem("userCusID", res.data.userId);
              navigate(0);
            } else {
              navigate('/login');
            }
          })
          .catch(err => {
            console.log(err);
          })
      }

    } else {
      api.post('permission/isAuth', { token: token }).then(res => {
        if (res.data.message != "Success") {
          window.localStorage.clear();
          alert("로그인 정보가 변경되어 로그아웃 되었습니다.");
          navigate('/login');
        } else {
          localStorage.setItem("stressSurvey", res.data.stressSurvey);
          localStorage.setItem("ownerFamID", res.data.ownerFamID);
          localStorage.setItem("sex", res.data.sex);
          // 심리상담 메뉴 노출 관리
          api.post('customer/api/v1/checkCounselTarget', { customerId: localStorage.getItem('userCusID') }).then(res => {
            localStorage.setItem("openConsultationReservation", res.data.data.isTarget);
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
        alert("잘못된 접근입니다.");
        navigate('/login');
      });
    }
  }

  const loadingContainer = {
    display: 'none',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(241, 242, 243, 0.5)',
    zIndex: 9999,
  }

  // 로그아웃
  function logout() {
    window.localStorage.clear();
    alert('로그아웃 되었습니다.');
    navigate('/login');
  }

  const LoadingComponent = () => {
    return (
      <Box
        sx={loadingContainer}
        id="loadingBox"
      >
        <Typography sx={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'black' }}>
          잠시만 기다려주세요.
        </Typography>
        <CircularProgress color="secondary" />
      </Box>
    )
  }

  return (
    <Paper sx={BottomNavi} >
      <List sx={{ width: '300px', maxWidth: 300, }}
        component="nav"
      >
        <Toolbar
          sx={{
            margin: "15px 0px",
            backgroundColor: '#232323',
          }}
        >
          <Stack
            sx={{ width: "100%" }}
            direction="row"
            justifyContent="center"
          >
            {
              window.localStorage.getItem("companyId") == null
                ? null
                : <Link to='/'><img src={window.localStorage.getItem("companyId") == 'CO#50' ? logo2 : logo} alt="logo" style={{ width: 200 }} /></Link>
            }
          </Stack>
        </Toolbar>

        {/* <ListItemButton
          component={Link}
          to="/"
          sx={BottomMenu}>
          <ListItemIcon>
            <HouseRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="home" />
        </ListItemButton> */}


        <ListItemButton
          sx={BottomMenu}
          onClick={() => handleClick('reservation')}
        >
          <ListItemIcon>
            <EventAvailableRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="예약서비스" />
          {openMenus.reservation ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openMenus.reservation} timeout="auto" unmountOnExit sx={childMenu}>
          <List component="div" disablePadding>
            <ListItemButton
              component={Link}
              to="/reservation"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="검진예약" />
            </ListItemButton>



            {
              localStorage.getItem('openConsultationReservation') == 'true'
                ? <ListItemButton
                  component={Link}
                  to="/ConsultationReservation"
                  sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <StarBorder />
                  </ListItemIcon>
                  <ListItemText primary="심리상담예약" />
                </ListItemButton>
                : ''
            }

            <ListItemButton
              component={Link}
              to="/MyPage/ReservationView"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="예약현황" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/MyPage/ReservationBeforeView"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="검진기록" />
            </ListItemButton>

            {
              localStorage.getItem('stressSurvey') == 'true'
                ? <ListItemButton
                  component={Link}
                  to="/stress"
                  sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <StarBorder />
                  </ListItemIcon>
                  <ListItemText primary="직무스트레스" />
                </ListItemButton>
                : ''
            }
            <ListItemButton
                component={Link}
                to="/MyPage/MyPage"
                sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="내정보 관리" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton
          sx={BottomMenu}
          onClick={() => handleClick('result')}
        >
          <ListItemIcon>
            <FactCheckRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="검진결과" />
          {openMenus.result ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openMenus.result} timeout="auto" unmountOnExit sx={childMenu}>
          <List component="div" disablePadding>
            <ListItemButton
              component={Link}
              to="/MyPage/HealthResult"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="종합결과" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/MyPage/HealthMResult"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="주요결과" />
            </ListItemButton>
            {
              localStorage.getItem('hraSurvey') == 'true'
                ? <ListItemButton
                  component={Link}
                  to="/hra"
                  sx={{ pl: 4 }}>
                  <ListItemIcon>
                    <StarBorder />
                  </ListItemIcon>
                  <ListItemText primary="뇌심혈관질환 발병위험도" />
                </ListItemButton>
                : ''
            }

          </List>
        </Collapse>

        <ListItemButton
          sx={BottomMenu}
          onClick={() => handleClick('healthInfo')}
        >
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="건강정보" />
          {openMenus.healthInfo ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openMenus.healthInfo} timeout="auto" unmountOnExit sx={childMenu}>
          <List component="div" disablePadding>
            <ListItemButton
              component={Link}
              to="/encyclopedia"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="질병백과" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton
          sx={BottomMenu}
          onClick={() => handleClick('guide')}
        >
          <ListItemIcon>
            <EventAvailableRoundedIcon />
          </ListItemIcon>
          <ListItemText primary="이용안내" />
          {openMenus.guide ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openMenus.guide} timeout="auto" unmountOnExit sx={childMenu}>
          <List component="div" disablePadding>
            <ListItemButton
              component={Link}
              to="/Notice/Notice"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="공지사항" />
            </ListItemButton>
            <ListItemButton
              component={Link}
              to="/comparisonHospital"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="병원별 검진항목 비교" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/Information"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="건강검진안내" />
            </ListItemButton>
          </List>
        </Collapse>

        <ListItemButton
          sx={BottomMenu}
          onClick={() => handleClick('service')}
        >
          <ListItemIcon>
            <SupportAgentIcon />
          </ListItemIcon>
          <ListItemText primary="고객센터" />
          {openMenus.service ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={openMenus.service} timeout="auto" unmountOnExit sx={childMenu}>
          <List component="div" disablePadding>
            <ListItemButton
              component={Link}
              to="/CustomerServiceFaq"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="자주묻는 질문" />
            </ListItemButton>

            <ListItemButton
              onClick={() => {
                navigate('/check/CreateCounsel', { state: { supportId: 0 } });
              }}
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="1:1 문의" />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/check/Counsel"
              sx={{ pl: 4 }}>
              <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="내문의 내역" />
            </ListItemButton>
          </List>
        </Collapse>

      </List>
      <Grid container className="logOut">
        <MainOffice />
      </Grid>
      {/*       
      <BottomNavigation
        showLabels
        value={bottomNavValue}
        onChange={(event, newValue) => {
          setBottomNavValue(newValue);
        }}
        sx={{ flexDirection: 'column', width: 300, height: 'auto' }}
      >
        <BottomNavigationAction
          component={Link}
          to="/"

          value="home"
          icon={<HouseRoundedIcon />}
          sx={BottomMenu}
          className="BottomMenu"
        />
        <BottomNavigationAction
          component={Link}
          to="/reservation"
          label="예약서비스"
          value="reservation"
          sx={BottomMenu}
          icon={<EventAvailableRoundedIcon />}
        />

        <BottomNavigationAction
          component={Link}
          to="/check"
          label="검진결과"
          value="check"
          sx={BottomMenu}
          icon={<FactCheckRoundedIcon />}
        />

        <BottomNavigationAction
          component={Link}
          to="/care"
          label="건강정보"
          value="care"
          sx={BottomMenu}
          icon={<VolunteerActivismRoundedIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to="/history"
          label="이용안내"
          value="history"
          sx={BottomMenu}
          icon={<ManageSearchRoundedIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to="/MoreMenu"
          label="고객센터"
          value="MoreMenu"
          sx={BottomMenu}
          icon={<DensityMediumIcon />}
        />


      </BottomNavigation> */}

      <Grid container sx={logOut}>
        <Grid item className="Cl_flex"><SvgIcon component={AccountCircleIcon}></SvgIcon><Typography sx={logout_name}>{userName || ''}님</Typography></Grid>

        <Grid item>|</Grid>
        <Grid item><Button onClick={logout} sx={logOutButton}><LogoutIcon sx={logOutButtonSvg} />로그아웃</Button></Grid>
      </Grid>

      {LoadingComponent()}
    </Paper>
  );
}

const BottomNavi = {
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2,
  height: '100%',
  bgcolor: '#232323'
}

const BottomMenu = {
  bgcolor: '#35383B',
  borderBottom: '1px solid #232323',
  p: '12px 18px',
  // p: 2,
  color: '#fff',
  '& .MuiSvgIcon-root': { color: '#fff', },

}

const logOut = {
  justifyContent: 'space-between',
  padding: '0px 20px',
  fontSize: '16px !important',
  height: '50px',
  alignItems: 'center',
  minHeight: '50px',
  color: '#fff',
  position: 'absolute',
  bottom: '230px'
}

const logout_name = {
  marginLeft: '8px !important',
  marginTop: '2px !important',
  cursor: 'default',
}

const logOutButton = {
  background: 'none',
  border: 'none',
  color: '#fff',
  fontSize: '15px !important',
  cursor: 'pointer',
  ':hover': {
    background: '#232323',
  },
}

const logOutButtonSvg = {
  marginRight: '7px',
}


const childMenu = {
  '& .MuiSvgIcon-root': { color: '#fff', },
  '& .MuiListItemText-primary': { color: '#fff', fontSize: 16, verticalAlign: 'top' },
}

export default Bottom;